import React from 'react';
import { AppInputTextFormik } from 'primitives/input/appInputText';

import { MaterialMatterport, PhotographerApplicationDTO } from 'appAPITypes';

import { FormikProps } from 'formik';
import { AppInputSelectFormik } from 'primitives/input/appInputSelect';
import { MatterportBrands } from '../joinPageConstants';
import { SwitchBoxFormik } from 'components/switch/switchBox';
import * as yup from 'yup';
import { AppInputTextareaFormik } from 'primitives/input/appInputTextarea';
import { getFrontMessage } from 'appMessageDefinitions';
import { RealisationLinksRows } from './realisationLinks';
import {
  ShCol,
  ShRow,
  ShSwitchBoxContainer,
  ShTitle,
} from '@shoootin/components-web';

export type MaterialMatterportSectionValues = Pick<
  PhotographerApplicationDTO,
  'hasMatterport' | 'matterportMaterial'
>;

export const MaterialMatterportSectionValidation = yup
  .object()
  .shape<MaterialMatterportSectionValues>({
    hasMatterport: yup.boolean(),
    matterportMaterial: yup.object().shape<MaterialMatterport>({
      realisationLinks: yup.array(yup.string()), // .url('ERROR not an url')),
      caseName: yup.string(),
      tripod: yup.string(),
      monitor: yup.string(),
      matterportComment: yup.string(),
    }),
  });

export const EmptyMaterialMatterportSection: MaterialMatterportSectionValues = {
  hasMatterport: false,
  matterportMaterial: {
    realisationLinks: [''], // empty Array [] doest not render component
    caseName: '',
    tripod: '',
    monitor: '',
    matterportComment: '',
  },
};

export const MaterialMatterportSection = ({
  form,
}: {
  form: FormikProps<PhotographerApplicationDTO>;
}) => {
  return (
    <SwitchBoxFormik
      form={form}
      name="hasMatterport"
      service="matterport"
      label={
        <ShTitle size={4} color={form.values.hasMatterport ? 'white' : 'black'}>
          Matterport
        </ShTitle>
      }
      footer={
        <RealisationLinksRows
          arrayName="matterportMaterial.realisationLinks"
          form={form}
        />
      }
    >
      <ShSwitchBoxContainer>
        <ShRow className="field-row wrap-s">
          <ShCol xs={60} md={20} lg={20}>
            <AppInputSelectFormik
              form={form}
              name="matterportMaterial.caseName"
              options={MatterportBrands}
              placeholderMessage={getFrontMessage(
                'form_prospectPhotographerMatterportMaterial_caseName_PlaceHolder',
              )}
              onOptionSelected={() => {}}
            />
          </ShCol>
          <ShCol xs={60} md={20} lg={20}>
            <AppInputTextFormik
              form={form}
              name="matterportMaterial.tripod"
              placeholderMessage={getFrontMessage(
                'form_prospectPhotographerMatterportMaterial_tripod_PlaceHolder',
              )}
              modifier="large"
            />
          </ShCol>
          <ShCol xs={60} md={20} lg={20}>
            <AppInputTextFormik
              form={form}
              name="matterportMaterial.monitor"
              placeholderMessage={getFrontMessage(
                'form_prospectPhotographerMatterportMaterial_monitor_PlaceHolder',
              )}
              modifier="large"
            />
          </ShCol>
        </ShRow>
        <ShRow className="field-row gap">
          <ShCol xs={60}>
            <AppInputTextareaFormik
              name="matterportMaterial.matterportComment"
              form={form}
              placeholderMessage={getFrontMessage(
                'form_prospectPhotographerMatterportMaterial_matterportComment_PlaceHolder',
              )}
              modifier="large"
            />
          </ShCol>
        </ShRow>
      </ShSwitchBoxContainer>
    </SwitchBoxFormik>
  );
};
